const routes = [
  {
    path: '/clients',
    name: 'clients',
    component: () => import(/* webpackChunkName: "CrmPage" */ './views/CrmPage.vue'),
    props: (route) => ({
      angularRoute: 'app.clients',
      query: route.query,
    }),
    meta: { i18n: 'client-pov' },
  },
];

export default routes;
